import React from 'react'
import { Button } from '@mui/material'

type BulkActionProps = {
  selectionModel: any,
}

const DataGridDefaultBulkActions = ({ selectionModel }: BulkActionProps) => {
  return <Button variant='text' color='secondary'>
    Bulk Delete {selectionModel.length} rows?
  </Button>
}

export default DataGridDefaultBulkActions